function filterNews(el) {
    const resultsEl = el.querySelector("#news-results");
    const tabsEl = el.querySelector("#news-tabs");
    const pagerEl = el.querySelector("#news-pagination");

    // Derive initial filter from active tab (server set), allow ''
    let activeTerm = tabsEl?.querySelector(".news-tab.is-active")?.dataset.term ?? "";

    // Try to read querystring on first boot (optional)
    const params = new URLSearchParams(window.location.search);
    const qsTerm = params.get("filter");
    const qsPage = parseInt(params.get("page") || "1", 9) || 1;
    if (qsTerm !== null && qsTerm !== activeTerm) {
        activeTerm = qsTerm;
        tabsEl?.querySelectorAll(".news-tab").forEach(t => {
            t.classList.toggle("is-active", (t.dataset.term ?? "") === activeTerm);
        });
    }

    // Initial pagination render (based on server query)
    // We don't have meta from PHP here; fetch once to sync or skip this for now.
    fetchResults(activeTerm, qsPage);

    // ---- Fetch helper
    async function fetchResults(term, page = 1) {
        // Treat 'all' as no filter
        const normalizedTerm = term === "all" ? "" : term;
        const fd = new FormData();
        fd.append("action", "mytheme_ep_filter");
        fd.append("nonce", EPFilters.nonce);
        fd.append("term", normalizedTerm);
        fd.append("paged", page);

        let text;
        try {
            const res = await fetch(EPFilters.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: fd
            });
            text = await res.text(); // read raw to diagnose
        } catch (e) {
            console.error("Network error:", e);
            resultsEl.innerHTML = "<p>Network error.</p>";
            pagerEl.innerHTML = "";
            return;
        }

        let json;
        try {
            json = JSON.parse(text);
        } catch (e) {
            console.error("Non-JSON response:", text);
            resultsEl.innerHTML = "<p>Server returned invalid JSON.</p>";
            pagerEl.innerHTML = "";
            return;
        }

        if (!json.success || !json.data) {
            resultsEl.innerHTML = "<p>Request failed.</p>";
            pagerEl.innerHTML = "";
            return;
        }

        resultsEl.innerHTML = json.data.html;
        renderPagination(json.data.current || 1, json.data.total || 1);
        updateUrl(normalizedTerm, json.data.current || 1);
    }

    // ---- Build pagination purely in JS
    function renderPagination(curr, tot) {
        if (!pagerEl) return;
        if (tot <= 1) { pagerEl.innerHTML = ""; return; }

        // Create the same structure as the PHP pagination
        const pageWidth = document.createElement("div");
        pageWidth.className = "page-width";
        
        const gridContainer = document.createElement("div");
        gridContainer.className = "grid space-between flex-space-between";
        
        // Previous arrow
        const prevPage = curr > 1 ? curr - 1 : null;
        const prevArrow = document.createElement("a");
        prevArrow.href = "#";
        prevArrow.className = `pagination-prev pagination--arrow ${!prevPage ? 'hidden' : ''}`;
        prevArrow.textContent = "← Previous";
        prevArrow.dataset.page = String(prevPage || 1);
        if (!prevPage) {
            prevArrow.style.visibility = "hidden";
        }
        
        // Pagination list
        const paginationList = document.createElement("ul");
        paginationList.className = "pagination grid no-list";
        
        // Windowed numeric pages with ellipses
        const win = 2;
        const start = Math.max(2, curr - win);
        const end = Math.min(tot - 1, curr + win);
        
        // First page
        const firstLi = document.createElement("li");
        if (curr === 1) {
            firstLi.className = "active";
            firstLi.textContent = "1";
        } else {
            const firstLink = document.createElement("a");
            firstLink.href = "#";
            firstLink.dataset.page = "1";
            firstLink.textContent = "1";
            firstLi.appendChild(firstLink);
        }
        paginationList.appendChild(firstLi);
        
        // Ellipsis before window if needed
        if (start > 2) {
            const ellipsisLi = document.createElement("li");
            ellipsisLi.className = "disabled";
            ellipsisLi.textContent = "…";
            paginationList.appendChild(ellipsisLi);
        }
        
        // Window pages
        for (let i = start; i <= end; i++) {
            const li = document.createElement("li");
            if (i === curr) {
                li.className = "active";
                li.textContent = String(i);
            } else {
                const link = document.createElement("a");
                link.href = "#";
                link.dataset.page = String(i);
                link.textContent = String(i);
                li.appendChild(link);
            }
            paginationList.appendChild(li);
        }
        
        // Ellipsis after window if needed
        if (end < tot - 1) {
            const ellipsisLi = document.createElement("li");
            ellipsisLi.className = "disabled";
            ellipsisLi.textContent = "…";
            paginationList.appendChild(ellipsisLi);
        }
        
        // Last page (only if total > 1)
        if (tot > 1) {
            const lastLi = document.createElement("li");
            if (curr === tot) {
                lastLi.className = "active";
                lastLi.textContent = String(tot);
            } else {
                const lastLink = document.createElement("a");
                lastLink.href = "#";
                lastLink.dataset.page = String(tot);
                lastLink.textContent = String(tot);
                lastLi.appendChild(lastLink);
            }
            paginationList.appendChild(lastLi);
        }
        
        // Next arrow
        const nextPage = curr < tot ? curr + 1 : null;
        const nextArrow = document.createElement("a");
        nextArrow.href = "#";
        nextArrow.className = `pagination-next pagination--arrow ${!nextPage ? 'hidden' : ''}`;
        nextArrow.textContent = "Next →";
        nextArrow.dataset.page = String(nextPage || tot);
        if (!nextPage) {
            nextArrow.style.visibility = "hidden";
        }
        
        // Assemble the structure
        gridContainer.appendChild(prevArrow);
        gridContainer.appendChild(paginationList);
        gridContainer.appendChild(nextArrow);
        pageWidth.appendChild(gridContainer);
        
        pagerEl.innerHTML = "";
        pagerEl.appendChild(pageWidth);
    }

    // ---- URL state (optional/shareable)
    function updateUrl(term, page) {
        const p = new URLSearchParams(window.location.search);
        if (term) p.set("filter", term); else p.delete("filter");
        if (page > 1) p.set("page", String(page)); else p.delete("page");
        const qs = p.toString();
        history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : ""));
    }

    // ---- Events
    tabsEl?.addEventListener("click", (e) => {
        const btn = e.target.closest(".news-tab");
        if (!btn) return;
        const term = btn.dataset.term ?? "";
        if (term === activeTerm) return;

        tabsEl.querySelectorAll(".news-tab").forEach(t => t.classList.remove("is-active"));
        btn.classList.add("is-active");
        activeTerm = term;

        fetchResults(activeTerm, 1); // reset to page 1
    });

    pagerEl?.addEventListener("click", (e) => {
        const link = e.target.closest("a[data-page]");
        if (!link) return;
        
        e.preventDefault();
        const page = parseInt(link.dataset.page, 9) || 1;
        fetchResults(activeTerm, page);
    });
}



[...document.querySelectorAll('#news-archive')].map(filterNews)